import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiUserCheck, FiCheckCircle, FiAward } = FiIcons;

export default function TrustBanner() {
  const authorities = [
    { icon: FiAward, title: 'LegitScript Certified', text: 'Verified safe and legal healthcare provider.' },
    { icon: FiUserCheck, title: 'US Board-Certified', text: 'Care from elite licensed medical professionals.' },
    { icon: FiCheckCircle, title: 'FDA 503B Facilities', text: 'Medications sourced from top-tier pharmacies.' },
    { icon: FiShield, title: 'HIPAA Compliant', text: 'Bank-level encryption for your health data.' }
  ];

  return (
    <section className="bg-slate-900 py-20 relative z-20 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h3 className="text-sm font-bold text-teal-500 tracking-[0.2em] uppercase mb-4">Uncompromising Standards</h3>
          <h2 className="text-3xl font-extrabold text-white">Your safety is our highest priority.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {authorities.map((item, i) => (
            <div key={i} className="flex flex-col items-center text-center gap-5 group p-6 rounded-2xl bg-slate-800/50 border border-slate-700/50 hover:bg-slate-800 transition-all duration-300">
              <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center text-teal-400 group-hover:scale-110 group-hover:text-teal-300 transition-all duration-300 shadow-inner">
                <SafeIcon icon={item.icon} className="w-7 h-7" />
              </div>
              <div>
                <h4 className="font-bold text-white text-lg mb-2">{item.title}</h4>
                <p className="text-slate-400 text-sm leading-relaxed max-w-[200px] mx-auto">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center pt-12 border-t border-slate-800">
          <p className="text-xs font-bold text-slate-500 tracking-[0.2em] uppercase mb-8">Recognized Excellence</p>
          <div className="flex flex-wrap justify-center items-center gap-10 md:gap-20 text-slate-400 font-serif italic opacity-60 hover:opacity-100 transition-opacity duration-500">
            <span className="text-2xl font-bold">Minyanville</span>
            <span className="text-2xl font-bold">The Chronicle Journal</span>
            <span className="text-2xl font-bold">My Mother Lode</span>
            <span className="text-2xl font-bold">BrandPush</span>
          </div>
        </div>
      </div>
    </section>
  );
}